import type {
  AddressInput,
  useCareProviderQuickListQuery$variables,
} from "@/modules/care-provider/simple-search/services/__generated__/useCareProviderQuickListQuery.graphql"
import type { CareProviderSearchType } from "@/types/__generated__/union-types"

type CareProviderQuickListQueryVariablesParameters = {
  patientId: string
  language: string
  searchType: CareProviderSearchType
  specialtyId?: string | null
  showInsurerNetwork: boolean
  patientAddress?: AddressInput | null
}

export const createCareProviderQuickListQueryVariables = ({
  patientId,
  language,
  searchType,
  specialtyId,
  showInsurerNetwork,
  patientAddress,
}: CareProviderQuickListQueryVariablesParameters): useCareProviderQuickListQuery$variables => ({
  patientId,
  language: language.toUpperCase(),
  searchType,
  specialtyId: specialtyId ?? null,
  showInsurerNetwork,
  address:
    showInsurerNetwork && patientAddress
      ? {
          city: patientAddress.city,
          countryCode: patientAddress.countryCode,
          houseNumberStreet: patientAddress.houseNumberStreet,
          postalCode: patientAddress.postalCode,
        }
      : null,
})
